module.exports = __webpack_public_path__ + "media/customizations/mywilloway/back-c12321e49b4c1ad0b297277d743ec1e4.jpg";